import React, { HTMLAttributes } from 'react';
import { EtiquetasStyle } from '../../libraries/EtiquetasThemes';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './Etiqueta.scss';
const rootClassName = 'component-etiqueta';
interface EtiquetaProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'children' | 'label'> {
  theme?: EtiquetasStyle;
  label?: string | number;
  icon?: React.ReactNode;
  fitContent?: boolean;
}

export default function Etiqueta({
  theme = EtiquetasStyle.Programas,
  label,
  icon,
  fitContent,
  ...props
}: EtiquetaProps) {
  return (
    <div
      {...props}
      className={getMergedClassNames([
        rootClassName,
        theme,
        fitContent ? 'fit-content' : undefined,
      ])}
    >
      {icon ? <div className={`${rootClassName}-icon`}>{icon}</div> : undefined}
      <div className={`${rootClassName}-text nunito`}>{label}</div>
    </div>
  );
}
